<section class="bfa-component-wrapper" *ngIf="data.success; else noData">
	<section class="section-separator"></section>
	<ng-container *ngIf="(data?.tabs)[0]?.config?.id === 'exposures.assetAllocation'">
		<section [id]="(data?.tabs)[0]?.config?.id" class="color-primary">
			<span class="title-main" dcrHTMLKey="PA_SUB_HEADER_ASSET_ALLOCATION">Asset Allocation</span>
			<info-bubble [dcrKey]="tabsData[0].config.title.infoBubble.key" [defaultValue]="tabsData[0].config.title.infoBubble.translated"></info-bubble>
		</section>
	</ng-container>
	<section *ngIf="asOfDate" class="subtitle margin-bottom-20">
		<span dcrHTMLKey="AS_OF_DATE_DYNAMIC" [dcrSubstitutions]="{ $asOfDate$: asOfDate }">As of $asOfDate$</span>
	</section>
	<bfa-tabs type="underline" [hideTabBarIfOneTab]="true" custom-classes="toggle-buttons">
		<ng-container *ngFor="let tab of tabsData; index as idx">
			<ng-container *ngIf="tab?.displayConfig?.active">
				<tab-panel [tab-title]="tabViewCategory[getTabCategory(tab)] | dcr : getTabCategory(tab)" [templateRef]="tabContent"></tab-panel>
				<ng-template #tabContent>
					<section class="relative-benchmark" *ngIf="tab?.config?.id?.includes('.benchmark')">
						<span dcrHTMLKey="RELATIVE_TO_BENCHMARK_LABEL">Relative To Benchmark:</span> {{ benchmarkPortfolioName }}
					</section>
					<aa-asset-allocation-slim
						[tab]="tab"
						*ngIf="tab?.config?.id !== 'exposures.assetAllocation.benchmark'"
						[customChartAttributes]="portfolioCustomChartAttribute"
					></aa-asset-allocation-slim>
					<aa-asset-allocation-slim
						[tab]="tab"
						*ngIf="tab?.config?.id === 'exposures.assetAllocation.benchmark'"
						type="bar"
						name="center-align-chart"
						[customChartAttributes]="benchmarkCustomChartAttributes"
					></aa-asset-allocation-slim>
				</ng-template>
			</ng-container>
		</ng-container>
	</bfa-tabs>
	<ac-disclosure [isExpandable]="false">
		<ac-tpm-disclosure></ac-tpm-disclosure>
		<span dcrHTMLKey="ASSET_ALLOCATION_DISCLAIMER">ASSET_ALLOCATION_DISCLAIMER</span>
	</ac-disclosure>
</section>
<ng-template #noData>
	<dz-progress-spinner *ngIf="data.isLoading"></dz-progress-spinner>
	<section *ngIf="!data.isLoading && data.error">
		<em class="not-applicable" [dcrHTMLKey]="data.error.errorCodes[0]">{{ data.error.debugMessage }}</em>
	</section>
</ng-template>
